import { Camera, House } from '@shared/assets';

import * as st from './index.module.scss';

const Type = ({ type }) => {
	const getText = () => {
		switch (type) {
			case 'ON':
				return 'Онлайн';
			case 'OF':
				return 'Личный прием';
			default:
				break;
		}
	};

	const getIcon = () => {
		switch (type) {
			case 'ON':
				return Camera;
			case 'OF':
				return House;
			default:
				break;
		}
	};

	return (
		<div className={st.type}>
			<div className={st.type__icon}>{getIcon()()}</div>
			<span className={st.type__text}>{getText()}</span>
		</div>
	);
};

export default Type;
